
// ── GraphQL ───────────────────────────────────────────────────────────────────

export const ADD_PATIENT = `
  mutation AddPatient($input: CreatePatientInput!) {
    addPatient(input: $input) { id name phone }
  }
`;

// The insurer is a POLICY, not a patient column: it follows the person between
// clinics, and `patients.insurance` is DERIVED from it by patientmanagement.
// Written against the patient id `addPatient` returns.
export const SET_PATIENT_POLICY = `
  mutation SetPatientPolicy($input: PatientPolicyInput!) {
    setPatientPolicy(input: $input) { id insurerId }
  }
`;

// The booked row comes back naming its SERVICE, so the toast and the day row can
// say what was booked without a refetch
// (docs/CLINIC_RECEPTION_SERVICE_INVOICE_DESIGN.md §S1).
export const CREATE_APPOINTMENT = `
  mutation CreateAppointment($input: AppointmentInput!) {
    createAppointment(input: $input) {
      id patientId doctorId dateTime status
      service { currency declarationId label unitPriceRial }
    }
  }
`;

// The same booking, also asking what each notification channel did. A second document
// rather than one more field on the first: a booking that notifies nobody must never
// select a field an older BFF does not have, or the whole booking fails validation.
export const CREATE_APPOINTMENT_NOTIFYING = `
  mutation CreateAppointmentNotifying($input: AppointmentInput!) {
    createAppointment(input: $input) {
      id patientId doctorId dateTime status
      service { currency declarationId label unitPriceRial }
      notifications { channel status reason detail }
    }
  }
`;

// ── Domain constants ──────────────────────────────────────────────────────────

// DAYS used to live here as a hardcoded Persian array — and one whose «پنج‌شنبه»
// carried a ZWNJ that Settings' own copy did not, so the same weekday had two
// spellings in one app. It is now `weekdayNames()` from `useTranslation()`,
// which is Saturday-first like the Iranian week and follows the reader.
export const DURATION_OPTIONS = [10, 15, 20, 30];

// The four above are shortcuts, not the domain. visit_duration_minutes is a plain
// nullable Integer in doctorpreference and the scheduling grid steps by whatever
// it is told, so a clinic may set 19 if that is how its doctor works. The bounds
// exist only to keep the UI honest: 0 or a negative would make the slot loop
// meaningless, and a visit longer than two hours is not a slot grid.
export const DURATION_MIN = 5;
export const DURATION_MAX = 120;

// The slot grid's ANCHOR: every slot is 08:00 plus or minus a whole number of visits.
// It is not where the grid starts — a doctor's grid covers the whole day and their
// shift decides which of it is bookable. It used to stop at END_HOUR, so a shift
// signed until 23:00 lost its last three hours to a window nobody had chosen. The
// scheduling service walks the same grid (FIRST_SLOT_ANCHOR_MIN in its services.py).
export const START_HOUR = 8;
// Opening hours for a grid with no shift to trim it — a service session booked on a
// coworker's calendar (ServiceBookingFlow): staff are held to no shift, so their
// diary is the only other judge.
export const END_HOUR   = 20;
export const DAY_MIN    = 24 * 60;

export const TIME_SLOTS = [];
for (let h = 0; h < 24; h++) {
  TIME_SLOTS.push({ h, m: 0,  label: `${String(h).padStart(2, '0')}:00` });
  TIME_SLOTS.push({ h, m: 30, label: `${String(h).padStart(2, '0')}:30` });
}

export const DOC_COLORS = ['#0173BE', '#00BEB2', '#7C3AED', '#D97706', '#059669', '#DC2626', '#0284C7'];
